/**
 * The KPI dashboard's row order (DOP-613), as `GET /api/kpi/dashboard-layout`
 * serves it: the default — Summit's sections, headings and names — and this
 * user's own arrangement, if they made one. Parsed at the boundary.
 */

import { z } from "zod/v3";

export const KpiLayoutMetricSchema = z.object({
	key: z.string(),
	label: z.string().nullable().optional(),
});

export const KpiLayoutSectionSchema = z.object({
	key: z.string(),
	label: z.string(),
	metrics: z.array(KpiLayoutMetricSchema),
});
export type KpiLayoutSection = z.infer<typeof KpiLayoutSectionSchema>;

export const KpiSavedLayoutSchema = z.object({
	sections: z.array(
		z.object({ key: z.string(), metrics: z.array(z.string()) }),
	),
});
export type KpiSavedLayout = z.infer<typeof KpiSavedLayoutSchema>;

export const KpiDashboardLayoutSchema = z.object({
	default: z.array(KpiLayoutSectionSchema),
	saved: KpiSavedLayoutSchema.nullable().optional(),
});
export type KpiDashboardLayout = z.infer<typeof KpiDashboardLayoutSchema>;
